import { useCallback, useEffect, useState } from 'react';

import { useDropdown } from '@/common/hooks/useDropdown';
import { useRouter } from 'next/navigation';

const initialValues = {
  search_query: '',
};

export const useSearchBar = props => {
  const { afterSubmit } = props;
  const [valid, setValid] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [isClient, setIsClient] = useState(false);
  const { elementRef, expanded: isAutoCompleteOpen, setExpanded: setIsAutoCompleteOpen } = useDropdown();
  const router = isClient ? useRouter() : null;

  useEffect(() => {
    setIsClient(true);
  }, []);

  // expand or collapse on input change
  const handleChange = useCallback(
    value => {
      const hasValue = !!value;
      const isValid = hasValue;
      setSearchValue(value?.value);
      setValid(isValid);
      setIsAutoCompleteOpen(hasValue);
    },
    [setIsAutoCompleteOpen, setValid],
  );

  // expand on focus
  // const handleFocus = useCallback(() => {
  //     setIsAutoCompleteOpen(true);
  // }, [setIsAutoCompleteOpen]);

  const handleFocus = () => {};

  // navigate on submit
  const handleSubmit = useCallback(
    ({ values }) => {
      const { search_query } = values;

      const defaultSearchQuery = 'deck boots';

      if (search_query != null && search_query.trim().length > 0) {
        router?.push?.(`/search.html?query=${search_query}`);
        setIsAutoCompleteOpen(false);

        if (afterSubmit) {
          afterSubmit();
        }
      } else {
        router?.push?.(`/search.html?query=${defaultSearchQuery} `);
        setIsAutoCompleteOpen(false);

        if (afterSubmit) {
          afterSubmit();
        }
      }
    },
    [router, afterSubmit, setIsAutoCompleteOpen],
  );

  return {
    containerRef: elementRef,
    handleChange,
    handleFocus,
    handleSubmit,
    initialValues,
    isAutoCompleteOpen,
    setIsAutoCompleteOpen,
    setValid,
    valid,
    searchValue,
  };
};
